<pcs-nav-link-item
  title="{{'features.title' | translate}}"
  [link]="notSeenFeaturesLink()"
  class="new-features d-flex align-items-center">
</pcs-nav-link-item>

<pcs-help-menu [pcsDocumentationLink]="pcsDocumentationLink"
               [mailPcsSupport]="mailPcsSupport">
</pcs-help-menu>

<pcs-button buttonStyle="link"
            [icon]="getFullScreenIcon()"
            title="navigation.fullScreen"
            ngClass="icon-fullscreen"
            (clicked)="toggleFullScreen()">
</pcs-button>

<pcs-user-settings-menu [currentUser]="currentUser" (logout)="logout.emit()">
</pcs-user-settings-menu>
